import { LozingsVormInputDto } from '@/lib/types';
import { Form, Input, Select, Typography } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type LozingsVormFormValue = Omit<LozingsVormInputDto, 'value'> & {
  value?: number;
};

interface Properties {
  teeltwijze: number;
  values: number[];
}

export const LozingsvormBase: FC<Properties> = ({ teeltwijze, values }) => {
  const { t } = useTranslation('input');
  const { Title } = Typography;
  const form = Form.useFormInstance();

  const [lozingsVormList, setLozingsVormList] = useState<LozingsVormFormValue[]>([]);

  useEffect(() => {
    const existingLozingsVorm: LozingsVormFormValue[] = form.getFieldValue('lozingsVorm') || [];
    const hasLozingsVorm = existingLozingsVorm.some(item => item.betrekkingTotTeeltwijze === teeltwijze);

    if (hasLozingsVorm) {
      setLozingsVormList(existingLozingsVorm);
      return;
    }

    const updatedLozingsVorm = [
      ...existingLozingsVorm,
      {
        betrekkingTotTeeltwijze: teeltwijze,
        value: undefined,
      },
    ];

    form.setFieldsValue({
      lozingsVorm: updatedLozingsVorm,
    });

    setLozingsVormList(updatedLozingsVorm);
  }, [teeltwijze, form]);

  const currentLozingIndex = lozingsVormList.findIndex(item => item.betrekkingTotTeeltwijze === teeltwijze);

  const handleSelectChange = (value: number) => {
    const updatedLozingsVorm = lozingsVormList.map((item, index) => (index === currentLozingIndex ? { ...item, value } : item));
    setLozingsVormList(updatedLozingsVorm);
  };

  return (
    <>
      <Title style={{ margin: '10px 0px' }} level={5}>
        {t('form.otherCompanyInfo.drainMethod.title')}
      </Title>
      <Typography>
        {teeltwijze === 0 && t('form.otherCompanyInfo.drainMethod.subtitleGrondteelt')}
        {teeltwijze === 1 && t('form.otherCompanyInfo.drainMethod.subtitleSubstraatteelt')}
      </Typography>

      {currentLozingIndex !== -1 && (
        <>
          <Form.Item name={['lozingsVorm', currentLozingIndex, 'betrekkingTotTeeltwijze']} initialValue={teeltwijze} hidden>
            <Input />
          </Form.Item>

          <Form.Item name={['lozingsVorm', currentLozingIndex, 'value']} rules={[{ required: true, message: '' }]}>
            <Select onChange={handleSelectChange} value={lozingsVormList[currentLozingIndex]?.value} style={{ width: '30%' }}>
              {values.map(value => (
                <Select.Option key={value} value={value} disabled={teeltwijze === 1 && value >= 4}>
                  {t(`form.otherCompanyInfo.drainMethod.option_${value + 1}`)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </>
      )}
    </>
  );
};
